export default function getBMI(weightInKg, heightInCm){
    if (!weightInKg || !heightInCm) return "";
    var bmi =  Math.round(weightInKg/(heightInCm*heightInCm)*1000000)/100;
    var bmiCategory = "Underweight";
    if(bmi>=30) bmiCategory = "Obese";
    else if (bmi>=25 && bmi <30) bmiCategory = "Overweight";
    else if (bmi>=18.5 && bmi <25) bmiCategory = "Normal";
    return bmi + " (" + bmiCategory + ")";
}